import * as materialColors from '@mui/material/colors'
import generateId from '../../../../utils/generateId'

export function generateRandomColor() {
  const colors = [
    materialColors.amber[200],
    materialColors.blue[200],
    materialColors.brown[200],
    materialColors.blueGrey[200],
    materialColors.cyan[200],
    materialColors.deepOrange[200],
    materialColors.deepPurple[200],
    materialColors.grey[200],
    materialColors.green[200],
    materialColors.indigo[200],
    materialColors.lightBlue[200],
    materialColors.lime[200],
    materialColors.lightGreen[200],
    materialColors.orange[200],
    materialColors.pink[200],
    materialColors.purple[200],
    materialColors.red[200],
    materialColors.teal[200],
    materialColors.yellow[200],
  ]

  return colors[Math.floor(Math.random() * colors.length)]
}


export function generateRandomOption(name) {
  return {
    id: generateId(),
    weight: 1,
    color: generateRandomColor(),
    name: name,
  }
}

export function reorderList(list, dragIndex, targetIndex) {
  if (dragIndex === targetIndex) {
    return list
  }

  let newList = [...list]

  const temp = newList[dragIndex]
  if (dragIndex < targetIndex) {
    for (let i = dragIndex; i < targetIndex; i++) {
      if (i + 1 < newList.length) {
        newList[i] = newList[i + 1]
      }
    }
    newList[targetIndex - 1] = temp
    return newList
  } else if (dragIndex > targetIndex) {
    for (let i = dragIndex; i > targetIndex; i--) {
      if (i > 0) {
        newList[i] = newList[i - 1]
      }
    }
    newList[targetIndex] = temp
    return newList
  }
}
